/* eslint-disable no-underscore-dangle */
import _ from 'underscore';
import { dataSource as GridDataSource } from 'projection-grid';

export const CHART_DATA_KEY = '@ns.performancetimeseries';

function translateOrderBy(dataSource, orderByParams) {
  const orderBy = _.chain(dataSource.normalizeOrderBy(orderByParams))
    .map(([key, direction]) => [
      key,
      direction > 0 ? 'ASC' : 'DESC',
    ])
    .value();

  return _.isEmpty(orderBy) ? null : orderBy;
}

function translateParams(dataSource, params) {
  return _.chain(params)
    .omit('skip', 'take', 'filter', 'orderby')
    .extend(_.pick({
      offset: params.skip,
      limit: params.take,
      where: params.filter,
      orderBy: translateOrderBy(dataSource, params.orderby),
    }, Boolean))
    .value();
}

export class JSGridChartDataSource extends GridDataSource.JSData {
  constructor(resource, options = {}) {
    super(resource, options);
    this.chartData = null;
    this.loadingCallback = null;
    this.successCallback = null;
    this.errorCallback = null;
  }
  query(params) {
    const options = _.defaults({}, params.options, this._options);
    if (this.loadingCallback) {
      this.loadingCallback();
    }
    return this._resource
      .findAll(translateParams(this, _.omit(params, 'options')), options)
      .then((data) => {
        if (_.isArray(data)) {
          try {
            this.updateChartData(JSON.parse(data.raw[CHART_DATA_KEY]));
            if (this.successCallback) {
              this.successCallback(this.chartData);
            }
          } catch (e) {
            if (this.errorCallback) {
              this.errorCallback(e);
            }
          }
          return ({
            items: data.slice(),
            totalCount: data.totalCount || 0,
          });
        }
        throw data;
      });
  }
  updateChartData(chartData) {
    this.chartData = chartData;
  }
  getChartData(successCallback, errorCallback) {
    this.successCallback = successCallback;
    this.errorCallback = errorCallback;
    if (this.successCallback && this.chartData) {
      this.successCallback(this.chartData);
    }
  }
  onLoading(loadingCallback) {
    this.loadingCallback = loadingCallback;
  }
}
